/**
 * Created by coolguy on 2017/4/15.
 */
import {Login} from '../util/ApiList';
import Ajax from '../util/ajax.js';
import CommonAction from './CommonAction';
const {
    ajax,ajaxCommon
} = Ajax;
const {
    ajaxStart,
} = CommonAction;

//actions
const LOGIN = "LOGIN";//登录
const LOGOUT = "LOGOUT";//登出

export default {
    LOGIN,
    login: (phone,password) => {
        return (dispatch)=>{
            dispatch(ajaxStart());
            let req = Login.login;
            return ajax({
                url:req.url,
                method:req.method,
                body:{phone,password}
            }).then((data)=>{
                dispatch({
                    type:LOGIN,
                    data:data
                });
                //都统一返回data，方便后续处理
                return data;
            });
        }
    },
    LOGOUT,
    logout: ()=>{
        window.sessionStorage.setItem('imsign', '');
        return ajaxCommon({
            api:Login.logout,
            success: (data)=>({
                type:LOGOUT,
                data
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/LoginAction.js